module.exports = __webpack_public_path__ + "img/black-week-3-estrelas.3c05b257.webp";